import axios from "axios";
import { getNotificationsUrl, postNotificationUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const postNotification = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(postNotificationUrl, data, config);
    return response;
};


export const getNotifications = async ({ filter = null }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(getNotificationsUrl + (filter || ""), config);

    return response;
};